export const FLOW_ID_COOKIE = "mcp_oauth_flow_id";
export const FLOW_STARTED_COOKIE = "mcp_oauth_flow_started";
export const FLOW_SOURCE_COOKIE = "mcp_oauth_flow_source";

export type SignInSource = "login_button" | "sso_hint";
